// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import App from './components/main/App'
import router from './router'
import store from './store'
import VueCurrencyInput from 'vue-currency-input'
import moment from 'vue-moment'
import VueTelInput from 'vue-tel-input'
import VueSanitize from 'vue-sanitize'
import VueClipboard from 'vue-clipboard2'
import VueLoading from 'vue-loading-overlay'
import SocialSharing from 'vue-social-sharing'
import VueSweetalert2 from 'vue-sweetalert2'
import VueCarousel from 'vue-carousel'
import VueSession from 'vue-session'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'vue-loading-overlay/dist/vue-loading.css'

Vue.use(VueClipboard)
Vue.use(VueTelInput)
Vue.use(VueSweetalert2)
let defaults = VueSanitize.defaults

Vue.use(VueCarousel)
Vue.use(VueSanitize, defaults)
Vue.use(SocialSharing)
Vue.use(moment)
Vue.use(VueSession)
Vue.use(Vuelidate)
Vue.use(VueLoading)
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: null,
    precision: {
      min: 2,
      max: 6
    },
    distractionFree: {
      hideNegligibleDecimalDigits: false,
      hideCurrencySymbol: true,
      hideGroupingSymbol: false
    },
    allowNegative: false
  }
})
/* eslint-disable no-new */
Object.filter = (obj, predicate) =>
  Object.fromEntries(Object.entries(obj).filter(predicate))

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

Vue.config.devtools = true
Vue.config.performance = true



// WEBPACK FOOTER //
// ./src/main.js